/**
 * @file 号码认证模块
 * @author wence
 */

import {
    GET_NUMBER_COMMON_LIST,
    GET_NUMBER_COMMON_INFO,
    GET_NUMBER_SEARCH_RESULT
} from '../actions/ActionTypes';

export function numberCommonList(state = [], action) {
    switch (action.type) {
        case GET_NUMBER_COMMON_LIST:
            return action.data;
        default:
            return state;
    }
}

export function numberCommonInfo(state = [], action) {
    switch (action.type) {
        case GET_NUMBER_COMMON_INFO:
            return action.data;
        default:
            return state;
    }
}

export function numberSearchResult(state = {}, action) {
    switch (action.type) {
        case GET_NUMBER_SEARCH_RESULT:
            return {...action.data, status: action.status, params: action.params};
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/numberAuth.js